<template>

    <section id="bookinglist">
        <div class="booking-grid">
            <h1>Alle reservationer</h1>
            <ul class="gridlist">
                <li v-for="b in bookings" class="card" :key="b.pk">
                    <booking :data="b" />
                </li>
            </ul>
            <p v-if="!bookings || bookings.length < 1">
                Der er ikke nogen reservationer.
            </p>
        </div>
    </section>

</template>

<script>

    import axios from '../../utils/Http.js'
    import booking from '../booking/BookingMini.vue'
    import { dateJs2django, displayJSDate, sortBookings } from '../../utils/Filters.js'
    
    export default {

        components: {
            booking
        },
        data: function() {
            return {
                
            }
        },
        computed: {
            auth: function() {
                return this.$store.getters.isAuthenticated
            },
            bookings: function() {
                return this.$store.getters.getBookingList
            }
        },
        methods: {
            fetchBookings: function() {
                const dj_now = encodeURIComponent(dateJs2django( new Date() )),
                    dj_future = encodeURIComponent(dateJs2django( new Date(new Date().getTime() + 315360000000) )),
                    options = `from=${ dj_now }&to=${ dj_future }`
                this.$store.dispatch('fetchBookings', options)
            }
        },
        created: function() {
            this.fetchBookings()
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #bookinglist {
        padding: 1rem;
    }

    @media screen and (min-width: $wide) {

        #bookinglist {
            display: flex;
            flex-flow: row nowrap;

            .booking-filter {
                order: 1;
                margin-right: 2rem;
            }
            .booking-grid {
                order: 2;
                width: calc(100vw - 2rem);
            }

        }

    }

</style>
